import { TabDrawerLayout } from '@Components/shared/layouts/TabDrawerLayout';
import { DrawerHeaderLayout } from '@Components/shared/layouts/DrawerHeaderLayout';
import { SetupRubberDuckRoundHeader } from './SetupRubberDuckRoundDrawerHeader';
import { Divider } from '@mui/material';
import { Stack } from '@mui/material';
import { useRubberDuckRoundDrawer } from '@Modal/hooks/rounds/useRubberDuckRoundDrawer';
import { useDispatch } from 'react-redux';
import { SetupRubberDuckRoundDrawerDetails } from './SetupRubberDuckRoundDrawerDetails';

export const SetupRubberDuckRoundDrawerContent: React.FC = () => {
  const dispatch = useDispatch();
  const { setShowRoundDrawer } = useRubberDuckRoundDrawer();

  return (
    <TabDrawerLayout
      header={
        <DrawerHeaderLayout
          currentSlug="/rounds"
          onClose={() => dispatch(setShowRoundDrawer(false))}
        >
          <SetupRubberDuckRoundHeader />
        </DrawerHeaderLayout>
      }
      footer={<></>}
    >
      <Stack>
        <Divider />
        <SetupRubberDuckRoundDrawerDetails />
      </Stack>
    </TabDrawerLayout>
  );
};
